// src/pages/blog/BlogPost.jsx
import React from "react";
import { useParams, Link } from "react-router-dom";
import "./blog.css";
import { posts } from "../../posts/postsIndex";

const BlogPost = () => {
  const { slug } = useParams();
  const post = posts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="blog-container">
        <p>Post not found. <Link to="/blog">Back to blog</Link></p>
      </div>
    );
  }

  return (
    <div className="blog-container">
      <Link className="blog-back" to="/blog">← Back to blog</Link>
      <article className="blog-article">
        <h1 className="blog-article-title">{post.title}</h1>
        <div className="blog-article-meta">
          <time>{new Date(post.date).toLocaleDateString()}</time>
          {post.repo && (
            <a href={post.repo} target="_blank" rel="noreferrer">View repo ↗</a>
          )}
        </div>
        <div
          className="blog-article-content"
          dangerouslySetInnerHTML={{ __html: post.contentHtml }}
        />
      </article>
    </div>
  );
};

export default BlogPost;
